import React from 'react'
import { Auth0Provider } from '@auth0/auth0-react'
import { auth0Config } from '../configs/auth0'

const Auth0ProviderWithConfig = ({ children }) => {
  const onRedirectCallback = (appState) => {
    history.push(window.location.pathname)
  }
  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={auth0Config.authorizationParams}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}

export default Auth0ProviderWithConfig 